import { apiClient } from './client';

export interface Workspace {
  id: string;
  name: string;
  slug: string;
  role: string;
  is_active: boolean;
}

export const workspacesApi = {
  list: async (): Promise<Workspace[]> => {
    const response = await apiClient.get<Workspace[]>('/workspaces');
    return response;
  },

  switch: async (organizationId: string): Promise<{ access_token: string; refresh_token: string }> => {
    const response = await apiClient.post<{ access_token: string; refresh_token: string }>('/workspaces/switch', { organization_id: organizationId });
    return response;
  },

  create: async (name: string): Promise<Workspace> => {
    const response = await apiClient.post<Workspace>('/workspaces', { name });
    return response;
  }
};
